import { IconType } from 'uangcermat-web-toolkit-v2';
import {
  SidebarMenuDefaultInterface,
  SidebarMenuInterface
} from 'uangcermat-web-toolkit-v2/build/src/blocks/Sidebar/Sidebar.type';

interface GuardedNavigationInterface {
  subMenu: SidebarMenuDefaultInterface[];
  titleStyles?: string;
  icon: IconType;
  iconStyles?: string;
  notifcationCount?: number;
  id: string;
  permission: string;
  title: string;
  navLink?: string;
}

const COMPANY_PERMISIONS = 'pinjamCermat';

const getCompanyPermisions = (permision: string) => {
  return permision?.split('.')[0];
};

export const getGuardedNavigation = ({
  userPermission,
  navConfig
}: {
  userPermission: Array<string>;
  navConfig: Array<SidebarMenuInterface>;
}): GuardedNavigationInterface[] => {
  const companyPermisions = getCompanyPermisions(userPermission?.[0]) === COMPANY_PERMISIONS;

  const filteredPermissions = navConfig
    ?.filter((item) => {
      const hasMainPermission = userPermission.includes(item.permission);
      const filteredSubMenu = item.subMenu
        ? item.subMenu.filter((subItem) => userPermission.includes(subItem.permission))
        : [];
      return hasMainPermission || filteredSubMenu.length > 0;
    })
    .map((item) => ({
      ...item,
      subMenu: item.subMenu
        ? item.subMenu.filter((subItem) => userPermission.includes(subItem.permission))
        : []
    }));

  return companyPermisions ? filteredPermissions : [];
};

export const getActiveIdAndParent = (
  pathName: string,
  guardedNavigation: Array<GuardedNavigationInterface>
): { activeId: string; activeParent: string } | null => {
  const pathWithoutQuery = pathName.split('?')[0];

  for (const menu of guardedNavigation) {
    if (menu.subMenu) {
      for (const subItem of menu.subMenu) {
        if (subItem.navLink && pathWithoutQuery.includes(subItem.navLink)) {
          return {
            activeId: subItem.navLink,
            activeParent: menu.id
          };
        }
      }
    }
  }

  return null;
};
